import styled from 'styled-components';

const PDFWrapper = styled.form`
  width: 100%;
  max-width: 1260px;
  padding: 30px 50px;
  border-radius: 15px;
  background: #fff;
  .pdf-layout { gap: 24px; }
  .pdf-layout > * { flex: 1; min-width: 0; }
  .pdf-actions { flex-wrap: wrap; gap: 16px; }
  .pdf-actions > button { margin: 0; }
  @media (max-width: 960px) {
    padding: 24px 16px;
    .pdf-layout { flex-direction: column; }
  }
`;

export { PDFWrapper };
